import $ from "jquery";
import React from "react";
import { useEffect } from "react";
// Styles
import "../../assets/saas/organisms/_datetime-picker.scss";
import moment from "moment";
const TimePickerDeclarations = ({ endTime, setEndTime, removeTimePickerInputBox, startTime, setStartTime, getData }) => {
    const [screenWidth, setScreenWidth] = React.useState(window.innerWidth);
    const [trigger, setTrigger] = React.useState(0);
    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [screenWidth]);
    useEffect(() => {
        if (trigger != 0) {
            getData();
        }
    }, [trigger]);
    const handleEditSearchBar = () => {
        if (window.location.href.indexOf("collections") > -1) {
            document.body.classList.add("editbar-collection");
        }
    };
    if (screenWidth > 768) {
        //if the element of class blue-bar is above window.scrollY == 0, scroll the window to the top. this must run every time the user scrolls both the window and the modal
        $("#timepicker").timepicker({
            timeFormat: "h:mm p",
            interval: 30,
            startTime: "12:00 a",
            dynamic: false,
            dropdown: true,
            scrollbar: true,
            change: function (time) {
                setEndTime([
                    "" +
                        time
                            .toLocaleTimeString("en-US", {
                            hour: "numeric",
                            minute: "2-digit",
                            hour12: true,
                        })
                            .toLowerCase(),
                    time.toLocaleTimeString("en-US", {
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: false,
                    }),
                ]);
                $(".ui-timepicker-container").addClass("closing");
                $(".ui-timepicker-container").removeClass("opening");
                $(".ui-timepicker-container").attr("style", "display: none;");
                $(".section-header").removeClass("hidden");
                $(".header").removeClass("hidden");
                setTimeout(() => {
                    setTrigger(Math.floor(Math.random() * 5000) + 1);
                    $(".ui-timepicker-container").removeClass("closing");
                }, 700);
                $("body").removeClass("noscroll");
                $("#timepicker").addClass("selected");
            },
            close: function () {
                removeTimePickerInputBox();
            },
        });
        //---------------------------------------------------------------------------------------------------------------------
        $("#tv").click(function (e) {
            handleEditSearchBar(); // Add this line
            $("#timepicker").timepicker("open");
            setTimeout(() => {
                $(".ui-corner-all").each(function () {
                    if ($(this).attr("data-time") == moment(endTime[1], "HH:mm").format("h:mm a").toUpperCase()) {
                        $(this).addClass("selected-hour");
                    }
                    else {
                        $(this).removeClass("selected-hour");
                    }
                });
                setTimeout(() => {
                    let selectedHour = $(".selected-hour");
                    if (selectedHour.length) {
                        let viewport = $(".ui-timepicker-viewport");
                        if (viewport.length) {
                            let currentScrollTop = viewport.scrollTop() || 0;
                            let selectedTop = selectedHour.position().top + currentScrollTop - 50;
                            viewport.scrollTop(selectedTop);
                        }
                    }
                }, 10);
            }, 10);
            e.stopPropagation();
        });
        //-----------------------------------------------------------------------------------------------------------------
        $("#timepicker1").timepicker({
            timeFormat: "h:mm p",
            interval: 30,
            startTime: "12:00 a",
            dynamic: false,
            dropdown: true,
            scrollbar: true,
            change: function (time) {
                setStartTime([
                    "" +
                        time
                            .toLocaleTimeString("en-US", {
                            hour: "numeric",
                            minute: "2-digit",
                            hour12: true,
                        })
                            .toLowerCase(),
                    time.toLocaleTimeString("en-US", {
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: false,
                    }),
                ]);
                $("#chat").removeClass("hidden");
                $("body").removeClass("noscroll");
                $(".ui-timepicker-container").addClass("closing");
                $(".ui-timepicker-container").removeClass("opening");
                $(".ui-timepicker-container").attr("style", "display: none;");
                $("#timepicker1").addClass("selected");
                $(".section-header").removeClass("hidden");
                $(".header").removeClass("hidden");
                setTimeout(() => {
                    if (sessionStorage.getItem("preloadSearchStarted") == "true") {
                        setTrigger(Math.floor(Math.random() * 5000) + 1);
                    }
                    $(".ui-timepicker-container").removeClass("closing");
                }, 700);
            },
            close: function () {
                removeTimePickerInputBox();
            },
        });
        $("#t1v").click(function (e) {
            handleEditSearchBar(); // Add this line
            $("#timepicker1").timepicker("open");
            setTimeout(() => {
                $(".ui-corner-all").each(function () {
                    if ($(this).attr("data-time") == moment(startTime[1], "HH:mm").format("h:mm a").toUpperCase()) {
                        $(this).addClass("selected-hour");
                    }
                    else {
                        $(this).removeClass("selected-hour");
                    }
                });
                setTimeout(() => {
                    let selectedHour = $(".selected-hour");
                    if (selectedHour.length) {
                        let viewport = $(".ui-timepicker-viewport");
                        if (viewport.length) {
                            let currentScrollTop = viewport.scrollTop() || 0;
                            let selectedTop = selectedHour.position().top + currentScrollTop - 50;
                            viewport.scrollTop(selectedTop);
                        }
                    }
                }, 10);
            }, 10);
            e.stopPropagation();
        });
    }
};
export default TimePickerDeclarations;
